import { useTranslation } from 'react-i18next';

import { CircleIcon } from '@/shared/assets/icons/circle-icon';
import {
  backupJobStatusColor,
  jobStatusColor,
  jobStatusIcon,
} from '@/shared/features/jobs/hooks/use-job-status/use-job-status.constants';
import { BACKUP_JOBS } from '@/shared/features/jobs/jobs.constants';
import { TJobStatus } from '@/shared/types/job-status.types';
import {
  FeatureEnum,
  PipelineExecutionStatusEnum,
} from '@/shared/types/types.generated';

export const useJobStatus = () => {
  const { t } = useTranslation();

  const getStatusColor = (status?: TJobStatus, jobType?: FeatureEnum) => {
    if (!status) {
      return 'grey';
    }
    return jobType && BACKUP_JOBS.includes(jobType)
      ? backupJobStatusColor[status]
      : jobStatusColor[status];
  };

  const getStatusIcon = (status?: TJobStatus) => {
    if (!status) {
      return <CircleIcon />;
    }
    return jobStatusIcon[status];
  };

  const getStatusLabel = (status?: TJobStatus, jobType?: FeatureEnum) => {
    const prefix =
      jobType && BACKUP_JOBS.includes(jobType)
        ? 'sync_execution_status'
        : 'job_execution_status';

    if (!status) {
      return t(`pipelines:${prefix}.not_started`);
    }
    return t(`pipelines:${prefix}.${status?.toLowerCase()}`);
  };

  const isJobRunning = (status?: TJobStatus) => {
    const openStatus: TJobStatus[] = [
      PipelineExecutionStatusEnum.NotStarted,
      PipelineExecutionStatusEnum.Pending,
      PipelineExecutionStatusEnum.Processing,
    ];
    if (!status) {
      return false;
    }
    return openStatus.includes(status);
  };

  return {
    getStatusColor,
    getStatusIcon,
    getStatusLabel,
    isJobRunning,
  };
};
